import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import Zone from "@insite/client-framework/Components/Zone";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { linkListStyles } from "@insite/content-library/Widgets/Basic/LinkList";
import { StyledButton } from "@insite/mobius/Clickable";
import GridContainer, { GridContainerProps, GridOffset, GridWrapper } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import getColor from "@insite/mobius/utilities/getColor";
import React, { FC } from "react";
import { css } from "styled-components";

interface OwnProps extends WidgetProps {
    extendedStyles?: FooterContainerStyles;
}

export interface FooterContainerStyles {
    widgetGridContainer?: GridContainerProps;
    linkList2GridItem?: GridItemProps;
    linkList3GridItem?: GridItemProps;
    linkList4GridItem?: GridItemProps;
    newsLetterGridItem?: GridItemProps;
    infoCenterGridItem?: GridItemProps;
    customerSupportGridItem?: GridItemProps;
    followUsGridItem?: GridItemProps;
    belowFooterGridItem?: GridItemProps;
    solutionGridItem?: GridItemProps;
    policiesGridItem?: GridItemProps;
    companyInfoGridItem?: GridItemProps;
    siteMapLinksGridItem?: GridItemProps;
}

export const footerContainerStyles: FooterContainerStyles = {
    widgetGridContainer: {
        css: css`
            margin: 0 auto;
            max-width: 1440px !important;
            padding: 0rem 2rem;
            > ${GridOffset} {
                width: 100%;
                margin: 0 auto;
            }
        `,
    },
    newsLetterGridItem: {
        width: 12,
        css: css`
            padding: 0px;
        `,
    },
    companyInfoGridItem: {
        width: [6, 6, 6, 2, 2],
        css: css`
            .title-wrapper {
                ${TypographyStyle} {
                    font-size: 16px;
                    cursor: auto;
                    color: #f6f4f6;
                    text-transform: capitalize;
                    font-family: "Roboto-Bold";
                    &:hover {
                        color: ${getColor("common.background")} !important;
                    }
                }
            }
            ${StyledButton} {
                cursor: pointer;
                color: #f6f4f6;
                outline: none;
                &:hover {
                    color: ${getColor("common.background")} !important;
                }
            }
            a > ${TypographyStyle} {
                font-size: 14px;
                line-height: 24px;
                margin-top: 10px;
                color: ${getColor("common.background")};
                &:hover {
                    color: ${getColor("primary")};
                }
            }
        `,
    },
    infoCenterGridItem: {
        width: [6, 6, 6, 2, 2],
        css: css`
            .title-wrapper {
                ${TypographyStyle} {
                    cursor: auto;
                    color: #f6f4f6;
                    font-size: 16px;
                    text-transform: capitalize;
                    font-family: "Roboto-Bold";
                    &:hover {
                        color: ${getColor("common.background")} !important;
                    }
                }
            }
            ${StyledButton} {
                cursor: pointer;
                color: #f6f4f6;
                outline: none;
                &:hover {
                    color: ${getColor("common.background")} !important;
                }
            }
            a > ${TypographyStyle} {
                font-size: 14px;
                line-height: 24px;
                margin-top: 10px;
                color: ${getColor("common.background")};
                &:hover {
                    color: ${getColor("primary")};
                }
            }
        `,
    },
    customerSupportGridItem: {
        width: [6, 6, 6, 2, 2],
        css: css`
            .title-wrapper {
                ${TypographyStyle} {
                    cursor: auto;
                    color: #f6f4f6;
                    font-size: 16px;
                    text-transform: capitalize;
                    font-family: "Roboto-Bold";
                    &:hover {
                        color: ${getColor("common.background")} !important;
                    }
                }
            }
            ${StyledButton} {
                cursor: pointer;
                color: #f6f4f6;
                outline: none;
                &:hover {
                    color: ${getColor("common.background")} !important;
                }
            }
            a > ${TypographyStyle} {
                font-size: 14px;
                line-height: 24px;
                margin-top: 10px;
                color: ${getColor("common.background")};
                &:hover {
                    color: ${getColor("primary")};
                }
            }
        `,
    },
    followUsGridItem: {
        width: [6, 6, 6, 2, 2],
        css: css`
            .title-wrapper {
                ${TypographyStyle} {
                    cursor: auto;
                    color: #f6f4f6;
                    font-size: 16px;
                    text-transform: capitalize;
                    font-family: "Roboto-Bold";
                    &:hover {
                        color: ${getColor("common.background")} !important;
                    }
                }
            }
            ${StyledButton} {
                cursor: pointer;
                color: #f6f4f6;
                outline: none;
                &:hover {
                    color: ${getColor("common.background")} !important;
                }
            }
            a > ${TypographyStyle} {
                font-size: 14px;
                line-height: 24px;
                margin-top: 10px;
                color: ${getColor("common.background")};
                &:hover {
                    color: ${getColor("primary")};
                }
            }
        `,
    },
    belowFooterGridItem: {
        width: 12,
        css: css`
            margin-bottom: 1rem !important;
            ${StyledButton} {
                outline: none;
            }
            ${TypographyStyle} {
                color: #f6f4f6;
                font-weight: 400;
                font-size: 14px;
                line-height: 24px;
                margin-top: 10px;
            }
            a {
                &:focus {
                    outline: none !important;
                }
            }
        `,
    },
    solutionGridItem: {
        width: [6, 6, 6, 2, 2],
        css: css`
            .title-wrapper {
                ${TypographyStyle} {
                    cursor: auto;
                    color: #f6f4f6;
                    font-size: 16px;
                    text-transform: capitalize;
                    font-family: "Roboto-Bold";
                    &:hover {
                        color: ${getColor("common.background")} !important;
                    }
                }
            }
            ${StyledButton} {
                cursor: pointer;
                color: #f6f4f6;
                outline: none;
                &:hover {
                    color: ${getColor("common.background")} !important;
                }
            }
            a > ${TypographyStyle} {
                font-size: 14px;
                line-height: 24px;
                margin-top: 10px;
                color: ${getColor("common.background")};
                &:hover {
                    color: ${getColor("primary")};
                }
            }
        `,
    },
    policiesGridItem: {
        width: [6, 6, 6, 2, 2],
        css: css`
            .title-wrapper {
                ${TypographyStyle} {
                    font-size: 16px;
                    text-transform: capitalize;
                    cursor: auto;
                    color: #f6f4f6;
                    font-family: "Roboto-Bold";
                    &:hover {
                        color: ${getColor("common.background")} !important;
                    }
                }
            }
            ${StyledButton} {
                cursor: pointer;
                color: #f6f4f6;
                outline: none;
                &:hover {
                    color: ${getColor("common.background")} !important;
                }
            }
            a > ${TypographyStyle} {
                font-size: 14px;
                line-height: 24px;
                margin-top: 10px;
                color: ${getColor("common.background")};
                &:hover {
                    color: ${getColor("primary")};
                }
            }
        `,
    },
    siteMapLinksGridItem: {
        width: 12,
        css: css`
            padding: 0;
            > div[class^="Wrapper"] {
                > ${GridWrapper} {
                    > ${GridOffset} {
                        width: 100%;
                        margin: 0px;
                    }
                }
            }
        `,
    },
};

linkListStyles.linkWrapper = {
    css: css`
        > a {
            font-size: 14px;
            > span {
                color: ${getColor("common.background")};
                text-transform: capitalize;
            }
        }
    `,
};

const FooterContainer: FC<OwnProps> = ({ id, extendedStyles }) => {
    const [styles] = React.useState(() => mergeToNew(footerContainerStyles, extendedStyles));
    return (
        <>
            <GridContainer {...styles.widgetGridContainer}>
                <GridItem {...styles.newsLetterGridItem}>
                    <Zone zoneName="NewsLetter" contentId={id} />
                </GridItem>
                <GridItem {...styles.companyInfoGridItem}>
                    <Zone zoneName="CompanyInfo" contentId={id} />
                </GridItem>
                <GridItem {...styles.infoCenterGridItem}>
                    <Zone zoneName="InfoCenter" contentId={id} />
                </GridItem>
                <GridItem {...styles.customerSupportGridItem}>
                    <Zone zoneName="CustomerSupport" contentId={id} />
                </GridItem>
                <GridItem {...styles.solutionGridItem}>
                    <Zone zoneName="Solution" contentId={id} />
                </GridItem>
                <GridItem {...styles.policiesGridItem}>
                    <Zone zoneName="Policies" contentId={id} />
                </GridItem>
                <GridItem {...styles.followUsGridItem}>
                    <Zone zoneName="FollowUs" contentId={id} />
                </GridItem>
                <GridItem {...styles.belowFooterGridItem}>
                    <Zone zoneName="CopyRight" contentId={id} />
                </GridItem>
            </GridContainer>
        </>
    );
};

const footerContainer: WidgetModule = {
    component: FooterContainer,
    definition: {
        group: "Footer",
        displayName: "Footer Container",
        allowedContexts: ["Footer"],
    },
};

export default footerContainer;
